import { render } from "./SuppliersView.vue?vue&type=template&id=baf7ad22&scoped=true"
import script from "./SuppliersView.vue?vue&type=script&lang=js"
export * from "./SuppliersView.vue?vue&type=script&lang=js"

import "./SuppliersView.vue?vue&type=style&index=0&id=baf7ad22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baf7ad22"]])

export default __exports__